import * as CookieConsent from "vanilla-cookieconsent";
import "@orestbida/iframemanager";

const im = iframemanager();
const language = document.documentElement.getAttribute('lang');

const CAT_NECESSARY = "necessary";
const CAT_ANALYTICS = "analytics";
const CAT_ADVERTISEMENT = "advertisement";
const CAT_FUNCTIONALITY = "functionality";
const CAT_SECURITY = "security";
const CAT_EXTERNAL_FUNCTIONALITY = "external_functionality";

const SERVICE_AD_STORAGE = 'ad_storage';
const SERVICE_AD_USER_DATA = 'ad_user_data';
const SERVICE_AD_PERSONALIZATION = 'ad_personalization';
const SERVICE_ANALYTICS_STORAGE = 'analytics_storage';
const SERVICE_FUNCTIONALITY_STORAGE = 'functionality_storage';
const SERVICE_PERSONALIZATION_STORAGE = 'personalization_storage';
const SERVICE_SECURITY_STORAGE = 'security_storage';

const EXTERNAL_FUNCTIONALITY_GOOGLE_MAPS = 'googlemaps';

const SERVICES_TRANSLATION = {
	cz: {
		[SERVICE_ANALYTICS_STORAGE]: 'Umožňuje ukládání (například cookies) související s analytikou, např. délku návštěvy.',
		[EXTERNAL_FUNCTIONALITY_GOOGLE_MAPS]: 'Google Maps - umožňuje zobrazení map',
		[SERVICE_AD_STORAGE]: 'Umožňuje ukládání (například cookies) související s reklamou.',
		[SERVICE_AD_USER_DATA]: 'Nastavuje souhlas pro odesílání uživatelských dat souvisejících s reklamou do Googlu.',
		[SERVICE_AD_PERSONALIZATION]: 'Nastavuje souhlas pro personalizovanou reklamu.',
	},
	en: {
		[SERVICE_ANALYTICS_STORAGE]: 'Enables storage (such as cookies) related to analytics, e.g., visit duration.',
		[EXTERNAL_FUNCTIONALITY_GOOGLE_MAPS]: 'Google Maps - enables map display',
		[SERVICE_AD_STORAGE]: 'Enables storage (such as cookies) related to advertising.',
		[SERVICE_AD_USER_DATA]: 'Sets consent for sending user data related to advertising to Google.',
		[SERVICE_AD_PERSONALIZATION]: 'Sets consent for personalized advertising.',
	},
	de: {
		[SERVICE_ANALYTICS_STORAGE]: 'Ermöglicht die Speicherung (wie z.B. Cookies) im Zusammenhang mit Analysen, z.B. Besuchsdauer.\n',
		[EXTERNAL_FUNCTIONALITY_GOOGLE_MAPS]: 'Google Maps - enables map display',
		[SERVICE_AD_STORAGE]: 'Google Maps - ermöglicht die Kartenanzeige',
		[SERVICE_AD_USER_DATA]: 'Legt die Einwilligung für die Übermittlung nutzerbezogener Werbedaten an Google fest.',
		[SERVICE_AD_PERSONALIZATION]: 'Legt die Einwilligung für personalisierte Werbung fest.',
	}
}

// Define dataLayer and the gtag function.
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

// Set default consent to 'denied' (this should happen before changing any other dataLayer)
gtag('consent', 'default', {
	[SERVICE_AD_STORAGE]: 'denied',
	[SERVICE_AD_USER_DATA]: 'denied',
	[SERVICE_AD_PERSONALIZATION]: 'denied',
	[SERVICE_ANALYTICS_STORAGE]: 'denied',
	[SERVICE_FUNCTIONALITY_STORAGE]: 'denied',
	[SERVICE_PERSONALIZATION_STORAGE]: 'denied',
	[SERVICE_SECURITY_STORAGE]: 'denied',
});

/**
 * Update gtag consent according to the users choices made in CookieConsent UI
 */
function updateGtagConsent() {
	gtag('consent', 'update', {
		[SERVICE_ANALYTICS_STORAGE]: CookieConsent.acceptedService(SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS) ? 'granted' : 'denied',
		[SERVICE_AD_STORAGE]: CookieConsent.acceptedService(SERVICE_AD_STORAGE, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
		[SERVICE_AD_USER_DATA]: CookieConsent.acceptedService(SERVICE_AD_USER_DATA, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
		[SERVICE_AD_PERSONALIZATION]: CookieConsent.acceptedService(SERVICE_AD_PERSONALIZATION, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
		[SERVICE_FUNCTIONALITY_STORAGE]: CookieConsent.acceptedService(SERVICE_FUNCTIONALITY_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
		[SERVICE_PERSONALIZATION_STORAGE]: CookieConsent.acceptedService(SERVICE_PERSONALIZATION_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
		[SERVICE_SECURITY_STORAGE]: CookieConsent.acceptedService(SERVICE_SECURITY_STORAGE, CAT_SECURITY) ? 'granted' : 'denied',
	});
}

CookieConsent.run({
	cookie: {
		name: 'beves_cookies',
	},

	// https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
	guiOptions: {
		consentModal: {
			layout: 'box inline',
			position: 'bottom right',
			equalWeightButtons: true,
			flipButtons: false
		},
		preferencesModal: {
			layout: 'box',
			equalWeightButtons: true,
			flipButtons: false
		}
	},

	// Trigger consent update when user choices change
	onFirstConsent: () => {
		updateGtagConsent();
	},
	onConsent: () => {
		updateGtagConsent();
	},
	onChange: () => {
		updateGtagConsent();
	},

	// Configure categories and services
	categories: {
		[CAT_NECESSARY]: {
			enabled: true,  // this category is enabled by default
			readOnly: true,  // this category cannot be disabled
		},
		[CAT_ANALYTICS]: {
			autoClear: {
				cookies: [
					{
						name: /^_ga/,   // regex: match all cookies starting with '_ga'
					},
					{
						name: '_gid',   // string: exact cookie name
					}
				]
			},
			// See: https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
			services: {
				[SERVICE_ANALYTICS_STORAGE]: {
					label: SERVICES_TRANSLATION[language][SERVICE_ANALYTICS_STORAGE]
				}
			}
		},
		[CAT_EXTERNAL_FUNCTIONALITY]: {
			enabled: false,
			services: {
				EXTERNAL_FUNCTIONALITY_GOOGLE_MAPS: {
					label: SERVICES_TRANSLATION[language][EXTERNAL_FUNCTIONALITY_GOOGLE_MAPS],
					onAccept: () => im.acceptService('googlemaps'),
					onReject: () => im.rejectService('googlemaps')
				}
			}
		},
		[CAT_ADVERTISEMENT]: {
			services: {
				[SERVICE_AD_STORAGE]: {
					label: SERVICES_TRANSLATION[language][SERVICE_AD_STORAGE],
				},
				[SERVICE_AD_USER_DATA]: {
					label: SERVICES_TRANSLATION[language][SERVICE_AD_USER_DATA],
				},
				[SERVICE_AD_PERSONALIZATION]: {
					label: SERVICES_TRANSLATION[language][SERVICE_AD_PERSONALIZATION],
				},
			}
		},
		// [CAT_FUNCTIONALITY]: {
		// 	enabled: false,
		// 	services: {
		// 		[SERVICE_FUNCTIONALITY_STORAGE]: {
		// 			label: 'Enables storage that supports the functionality of the website or app e.g. language settings.',
		// 		},
		// 		[SERVICE_PERSONALIZATION_STORAGE]: {
		// 			label: 'Enables storage related to personalization e.g. video recommendations.',
		// 		},
		// 	}
		// },
		// [CAT_SECURITY]: {
		// 	enabled: false,
		// 	services: {
		// 		[SERVICE_SECURITY_STORAGE]: {
		// 			label: 'Enables storage related to security such as authentication functionality, fraud prevention, and other user protection.',
		// 		},
		// 	}
		// }
	},

	language: {
		default: language,
		translations: {
			cz: {
				consentModal: {
					title: 'Web používá cookies',
					description: 'Naše webové stránky používají nezbytné soubory cookies k zajištění správné funkčnosti. Dále používáme sledovací (tj. výkonnostní/analytické) soubory cookies, abychom pochopili jak stránky používáte. Sledovací cookies se ukládají pouze po vašem souhlasu. <a aria-label="Cookie policy" class="cc-link" href="https://www.beves.cz/zasady-zpracovani-osobnich-udaju">Váš souhlas</a> k využití jednotlivých dat, které nám dále pomáhají s vylepšováním našich služeb. Souhlas udělíte kliknutím na tlačítko "Souhlasím".',
					acceptAllBtn: 'Souhlasím',
					acceptNecessaryBtn: 'Odmítnout',
					showPreferencesBtn: 'Nastavení',
				},
				preferencesModal: {
					title: 'Správa předvoleb souborů cookie',
					acceptAllBtn: 'Přijmout vše',
					acceptNecessaryBtn: 'Odmítnout vše',
					savePreferencesBtn: 'Přijmout aktuální výběr',
					closeIconLabel: 'Zavřít okno',
					sections: [
						{
							title: "Použití cookies",
							description: "Používáme soubory cookie k zajištění základních funkcí webu a ke zlepšení vašeho online zážitku."
						},
						{
							title: 'Nezbytné cookies',
							description: 'Tyto cookies jsou nezbytné pro správné fungování webu beves.cz.',
							linkedCategory: CAT_NECESSARY,
							cookieTable: {
								headers: {
									name: "Název",
									domain: "Služba",
									description: "Popis",
									expiration: "Doba platnosti"
								},
								body: [
									{
										name: 'beves.cz',
										domain: '.beves.cz',
										description: 'Vlastní cookie pro potřeby nastavení zabezpečení aplikace.',
										expiration: '14 dní',
									},
								]
							},
						},
						{
							title: "Analytika",
							description: 'Soubory cookie používané pro analytiku pomáhají shromažďovat data, která umožňují službám pochopit, jak uživatelé interagují s konkrétní službou. Tyto poznatky umožňují službám zlepšovat obsah a vytvářet lepší funkce pro zlepšení uživatelského zážitku.',
							linkedCategory: CAT_ANALYTICS,
							cookieTable: {
								headers: {
									name: "Název",
									domain: "Služba",
									description: "Popis",
									expiration: "Doba platnosti"
								},
								body: [
									{
										name: "_ga",
										domain: "Google Analytics",
										description: "Soubor cookie nastavený službou <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>",
										expiration: "Vyprší po 12 dnech"
									},
									{
										name: "_gid",
										domain: "Google Analytics",
										description: "Soubor cookie nastavený službou <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>",
										expiration: "Session"
									},
									{
										name: "_fbp",
										domain: ".beves.cz",
										description: "Cookie služby Facebook.",
										expiration: "3 měsíce",
									},
									{
										name: "_gcl_au",
										domain: ".beves.cz",
										description: "Cookie služby Google Tag Manager.",
										expiration: "3 měsíce",
									},
									{
										name: "CLID",
										domain: "www.clarity.ms",
										description: "Identifikuje, kdy Clarity poprvé zaznamenala tohoto uživatele na jakémkoli webu využívajícím Clarity.",
										expiration: "1 rok"
									},
									{
										name: "MUID",
										domain: ".bing.com",
										description: "Identifikuje unikátní webové prohlížeče navštěvující weby Microsoftu. Tyto cookies jsou používány pro reklamu, analýzu webu a další operační účely.",
										expiration: "1 rok",
									},
									{
										col1: "SM",
										domain: ".c.clarity.ms",
										description: "Používá se k synchronizaci MUID napříč doménami Microsoftu.",
										expiration: "Do ukončení relace"
									}
								]
							}
						},
						{
							title: "Externí funkce",
							description: 'Soubory cookie používané pro externí funkce pomáhají zobrazovat mapy od společnosti Google.',
							linkedCategory: CAT_EXTERNAL_FUNCTIONALITY,
							cookieTable: {
								headers: {
									name: "Název",
									domain: "Služba",
									description: "Popis",
									expiration: "Doba platnosti"
								},
								body: [
									{
										name: "NID",
										domain: "Google Maps",
										description: "Soubor cookie nastavený službou <a href=\"https://policies.google.com/technologies/cookies?hl=cs\">Google Maps</a> pro ukládání uživatelských preferencí a dalších informací, zejména pro správné zobrazování map.",
										expiration: "Vyprší přibližně po 183 dnech"
									},
									{
										name: "CONSENT",
										domain: "Google Maps",
										description: "Soubor cookie nastavený službou <a href=\"https://policies.google.com/technologies/cookies?hl=cs\">Google Maps</a>, který slouží k uložení informací o uživatelově souhlasu s používáním různých kategorií souborů cookie.",
										expiration: "Vyprší po 6084 dnech (cca 20 let)"
									},
									{
										name: "1P_JAR",
										domain: "Google Maps",
										description: "Soubor cookie nastavený službou <a href=\"https://policies.google.com/technologies/cookies?hl=cs\">Google Maps</a> pro analytické účely a zlepšení poskytovaných služeb (např. zobrazování personalizovaných reklam).",
										expiration: "Vyprší přibližně po 30 dnech"
									}
								]
							}
						},
						{
							title: 'Reklama',
							description: 'Google používá soubory cookie pro reklamu, včetně zobrazování a vykreslování reklam, personalizace reklam (v závislosti na vašem nastavení reklam na <a href=\"https://g.co/adsettings\">g.co/adsettings</a>), omezení počtu zobrazení jedné reklamy uživateli, ztlumení reklam, které jste si zvolili přestat zobrazovat, a měření účinnosti reklam.',
							linkedCategory: CAT_ADVERTISEMENT,
						},
						// {
						// 	title: 'Funkčnost',
						// 	description: 'Soubory cookie používané pro funkčnost umožňují uživatelům interagovat se službou nebo webem a přistupovat k funkcím, které jsou pro tuto službu zásadní. Mezi tyto zásadní funkce patří například výběr jazyka uživatelem, optimalizace produktů pro udržení a zlepšení služby a uchovávání informací souvisejících s uživatelskou relací, například obsah nákupního košíku.',
						// 	linkedCategory: CAT_FUNCTIONALITY,
						// },
						// {
						// 	title: 'Bezpečnost',
						// 	description: 'Soubory cookie používané pro bezpečnost ověřují uživatele, zabraňují podvodům a chrání uživatele při jejich interakci se službou.',
						// 	linkedCategory: CAT_SECURITY,
						// },
						{
							title: 'Další informace',
							description: 'Pro jakékoli dotazy týkající se zásad používání souborů cookie a vašich možností nás prosím <a href="https://www.beves.cz/kontakty">kontaktujte</a>.'
						}
					]
				}
			},
			en: {
				consentModal: {
					title: 'Website uses cookies',
					description: 'Our website uses necessary cookies to ensure proper functionality. We also use tracking (i.e., performance/analytical) cookies to understand how you use the site. Tracking cookies are stored only with your consent. <a aria-label="Cookie policy" class="cc-link" href="https://www.beves.cz/zasady-zpracovani-osobnich-udaju">Your consent</a> to use individual data helps us improve our services. You can give consent by clicking the "I Agree" button.',
					acceptAllBtn: 'I Agree',
					acceptNecessaryBtn: 'Decline',
					showPreferencesBtn: 'Settings',
				},
				preferencesModal: {
					title: 'Cookie Preferences Management',
					acceptAllBtn: 'Accept All',
					acceptNecessaryBtn: 'Decline All',
					savePreferencesBtn: 'Accept Current Selection',
					closeIconLabel: 'Close Window',
					services: {
						[SERVICE_ANALYTICS_STORAGE]: {
							label: 'Test',
						}
					},
					sections: [
						{
							title: "Cookie Usage",
							description: "We use cookies to ensure basic website functions and to improve your online experience."
						},
						{
							title: 'Necessary Cookies',
							description: 'These cookies are essential for the proper functioning of the beves.cz website.',
							linkedCategory: CAT_NECESSARY,
							cookieTable: {
								headers: {
									name: "Name",
									domain: "Service",
									description: "Description",
									expiration: "Expiration"
								},
								body: [
									{
										name: 'beves.cz',
										domain: '.beves.cz',
										description: 'Custom cookie for application security settings.',
										expiration: '14 days',
									},
								]
							},
						},
						{
							title: "Analytics",
							description: 'Cookies used for analytics help collect data that enable services to understand how users interact with a specific service. These insights allow services to improve content and create better features to enhance the user experience.',
							linkedCategory: CAT_ANALYTICS,
							cookieTable: {
								headers: {
									name: "Name",
									domain: "Service",
									description: "Description",
									expiration: "Expiration"
								},
								body: [
									{
										name: "_ga",
										domain: "Google Analytics",
										description: "Cookie set by <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>",
										expiration: "Expires after 12 days"
									},
									{
										name: "_gid",
										domain: "Google Analytics",
										description: "Cookie set by <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>",
										expiration: "Session"
									},
									{
										name: "_fbp",
										domain: ".beves.cz",
										description: "Cookie des Facebook-Dienstes.",
										expiration: "3 Monate",
									},
									{
										name: "_gcl_au",
										domain: ".beves.cz",
										description: "Cookie des Google Tag Manager-Dienstes.",
										expiration: "3 Monate",
									},
									{
										name: "CLID",
										domain: "www.clarity.ms",
										description: "Identifiziert, wann Clarity diesen Benutzer zum ersten Mal auf einer Website mit Clarity erfasst hat.",
										expiration: "1 Jahr"
									},
									{
										name: "MUID",
										domain: ".bing.com",
										description: "Identifiziert eindeutige Webbrowser, die Microsoft-Websites besuchen. Diese Cookies werden für Werbung, Website-Analyse und andere betriebliche Zwecke verwendet.",
										expiration: "1 Jahr",
									},
									{
										col1: "SM",
										domain: ".c.clarity.ms",
										description: "Wird verwendet, um MUID über Microsoft-Domains hinweg zu synchronisieren.",
										expiration: "Bis zum Ende der Sitzung"
									}
								]
							}
						},
						{
							title: "External Functionality",
							description: 'Cookies used for external functionality help display maps from Google.',
							linkedCategory: CAT_EXTERNAL_FUNCTIONALITY,
							cookieTable: {
								headers: {
									name: "Name",
									domain: "Service",
									description: "Description",
									expiration: "Expiration"
								},
								body: [
									{
										name: "NID",
										domain: "Google Maps",
										description: "Cookie set by <a href=\"https://policies.google.com/technologies/cookies?hl=en\">Google Maps</a> for storing user preferences and other information, especially for proper map display.",
										expiration: "Expires after approximately 183 days"
									},
									{
										name: "CONSENT",
										domain: "Google Maps",
										description: "Cookie set by <a href=\"https://policies.google.com/technologies/cookies?hl=en\">Google Maps</a> that stores information about the user's consent to use various cookie categories.",
										expiration: "Expires after 6084 days (approx. 20 years)"
									},
									{
										name: "1P_JAR",
										domain: "Google Maps",
										description: "Cookie set by <a href=\"https://policies.google.com/technologies/cookies?hl=en\">Google Maps</a> for analytical purposes and service improvement (e.g., displaying personalized ads).",
										expiration: "Expires after approximately 30 days"
									}
								]
							}
						},
						{
							title: 'Advertising',
							description: 'Google uses cookies for advertising, including displaying and rendering ads, personalizing ads (depending on your ad settings at <a href="https://g.co/adsettings">g.co/adsettings</a>), limiting how many times a user sees an ad, muting ads you\'ve chosen to stop seeing, and measuring ad effectiveness.',
							linkedCategory: CAT_ADVERTISEMENT,
						},
						{
							title: 'More Information',
							description: 'For any questions regarding our cookie policy and your options, please <a href="https://www.beves.cz/kontakty">contact us</a>.'
						}
					]
				}
			},
			de: {
				consentModal: {
					title: 'Website verwendet Cookies',
					description: 'Unsere Website verwendet notwendige Cookies, um die korrekte Funktionalität zu gewährleisten. Wir verwenden auch Tracking-Cookies (d.h. Performance-/Analyse-Cookies), um zu verstehen, wie Sie die Website nutzen. Tracking-Cookies werden nur mit Ihrer Zustimmung gespeichert. <a aria-label="Cookie policy" class="cc-link" href="https://www.beves.cz/zasady-zpracovani-osobnich-udaju">Ihre Einwilligung</a> zur Nutzung einzelner Daten hilft uns, unsere Dienstleistungen zu verbessern. Sie erteilen Ihre Einwilligung durch Klicken auf die Schaltfläche "Ich stimme zu".',
					acceptAllBtn: 'Ich stimme zu',
					acceptNecessaryBtn: 'Ablehnen',
					showPreferencesBtn: 'Einstellungen',
				},
				preferencesModal: {
					title: 'Verwaltung der Cookie-Einstellungen',
					acceptAllBtn: 'Alle akzeptieren',
					acceptNecessaryBtn: 'Alle ablehnen',
					savePreferencesBtn: 'Aktuelle Auswahl akzeptieren',
					closeIconLabel: 'Fenster schließen',
					sections: [
						{
							title: "Verwendung von Cookies",
							description: "Wir verwenden Cookies, um grundlegende Funktionen der Website zu gewährleisten und Ihr Online-Erlebnis zu verbessern."
						},
						{
							title: 'Notwendige Cookies',
							description: 'Diese Cookies sind für das ordnungsgemäße Funktionieren der Website beves.cz unerlässlich.',
							linkedCategory: CAT_NECESSARY,
							cookieTable: {
								headers: {
									name: "Name",
									domain: "Dienst",
									description: "Beschreibung",
									expiration: "Gültigkeitsdauer"
								},
								body: [
									{
										name: 'beves.cz',
										domain: '.beves.cz',
										description: 'Eigenes Cookie für die Sicherheitseinstellungen der Anwendung.',
										expiration: '14 Tage',
									},
								]
							},
						},
						{
							title: "Analytik",
							description: 'Cookies für Analysezwecke helfen bei der Erfassung von Daten, die es Diensten ermöglichen zu verstehen, wie Benutzer mit einem bestimmten Dienst interagieren. Diese Erkenntnisse ermöglichen es Diensten, Inhalte zu verbessern und bessere Funktionen zur Verbesserung des Benutzererlebnisses zu entwickeln.',
							linkedCategory: CAT_ANALYTICS,
							cookieTable: {
								headers: {
									name: "Name",
									domain: "Dienst",
									description: "Beschreibung",
									expiration: "Gültigkeitsdauer"
								},
								body: [
									{
										name: "_ga",
										domain: "Google Analytics",
										description: "Cookie, das von <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a> gesetzt wird",
										expiration: "Läuft nach 12 Tagen ab"
									},
									{
										name: "_gid",
										domain: "Google Analytics",
										description: "Cookie, das von <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a> gesetzt wird",
										expiration: "Session"
									}
								]
							}
						},
						{
							title: "Externe Funktionen",
							description: 'Cookies für externe Funktionen helfen bei der Anzeige von Karten von Google.',
							linkedCategory: CAT_EXTERNAL_FUNCTIONALITY,
							cookieTable: {
								headers: {
									name: "Name",
									domain: "Dienst",
									description: "Beschreibung",
									expiration: "Gültigkeitsdauer"
								},
								body: [
									{
										name: "NID",
										domain: "Google Maps",
										description: "Cookie, das von <a href=\"https://policies.google.com/technologies/cookies?hl=de\">Google Maps</a> gesetzt wird, um Benutzereinstellungen und andere Informationen zu speichern, insbesondere für die korrekte Anzeige von Karten.",
										expiration: "Läuft nach etwa 183 Tagen ab"
									},
									{
										name: "CONSENT",
										domain: "Google Maps",
										description: "Cookie, das von <a href=\"https://policies.google.com/technologies/cookies?hl=de\">Google Maps</a> gesetzt wird und Informationen über die Zustimmung des Benutzers zur Verwendung verschiedener Cookie-Kategorien speichert.",
										expiration: "Läuft nach 6084 Tagen ab (ca. 20 Jahre)"
									},
									{
										name: "1P_JAR",
										domain: "Google Maps",
										description: "Cookie, das von <a href=\"https://policies.google.com/technologies/cookies?hl=de\">Google Maps</a> für Analysezwecke und zur Verbesserung der angebotenen Dienste gesetzt wird (z.B. Anzeige personalisierter Werbung).",
										expiration: "Läuft nach etwa 30 Tagen ab"
									}
								]
							}
						},
						{
							title: 'Werbung',
							description: 'Google verwendet Cookies für Werbung, einschließlich der Anzeige und Darstellung von Anzeigen, der Personalisierung von Anzeigen (abhängig von Ihren Werbeeinstellungen auf <a href=\"https://g.co/adsettings\">g.co/adsettings</a>), der Begrenzung der Häufigkeit, mit der ein Benutzer eine Anzeige sieht, der Stummschaltung von Anzeigen, die Sie nicht mehr sehen möchten, und der Messung der Werbewirksamkeit.',
							linkedCategory: CAT_ADVERTISEMENT,
						},
						{
							title: 'Weitere Informationen',
							description: 'Bei Fragen zu unseren Cookie-Richtlinien und Ihren Optionen <a href="https://www.beves.cz/kontakty">kontaktieren Sie uns</a> bitte.'
						}
					]
				}
			},
		}
	}
});

